const schema = {
  '@context': 'https://schema.org',
  '@type': 'Corporation',
  description:
    'More than an applicant tracking system, Workable\'s talent acquisition software helps teams find candidates, evaluate applicants and make the right hire, faster. Since 2012, more than 27,000 companies have used our recruiting software to hire 1.5 million candidates. We’re interested in the way people interact with the world, and we make technology to empower people. So we use our curiosity and ambition to create software that helps companies source the best talent, communicate more effectively and scale faster.',
  name: 'Workable',
  url: 'https://www.workable.com',
  logo: 'https://get.workable.com/hubfs/workable-logo-1.png',
  sameAs: [
    'https://resources.workable.com',
    'https://www.facebook.com/workable',
    'https://twitter.com/workable',
    'https://www.instagram.com/workable/',
    'https://www.youtube.com/c/WorkableSoftware',
    'https://www.linkedin.com/company/workable-software',
    'https://www.crunchbase.com/organization/workable-hr'
  ],
  image: 'https://www.workable.com/static/images/about/our-story_2x.png',
  address: [
    {
      '@type': 'PostalAddress',
      streetAddress: '83 Morse Street, Building 6',
      addressLocality: 'Norwood, Massachusetts',
      postalCode: '02062',
      addressCountry: 'USA'
    },
    {
      '@type': 'PostalAddress',
      streetAddress: '95-97 Kifisias Ave.',
      addressLocality: 'Marousi',
      postalCode: '151 25',
      addressCountry: 'Greece'
    },
    {
      '@type': 'PostalAddress',
      streetAddress: '5 Golden Square, 5th Floor',
      addressLocality: 'London',
      postalCode: 'W1F 9BS',
      addressCountry: 'UK'
    }
  ],
  telephone: [process.env.NEXT_PUBLIC_PHONE_NUMBER_ROW, process.env.NEXT_PUBLIC_PHONE_NUMBER_UK],
  founders: [
    {
      '@type': 'Person',
      name: 'Nikos Moraitakis'
    },
    {
      '@type': 'Person',
      name: 'Spyros Magiatis'
    }
  ],
  foundingDate: '2012'
};

const OrgSchema = () => (
  <script
    type="application/ld+json"
    // eslint-disable-next-line react/no-danger
    dangerouslySetInnerHTML={{
      __html: JSON.stringify(schema)
    }}
  />
);

export default OrgSchema;
